import { Field, TextField, YesNoCards, OptionCards } from "@/components/controls";
import { AVAILABLE_DAYS } from "@/lib/formConfig";

export default function StepAvailability({ data, setField }) {
  return (
    <div className="space-y-7">
      <div>
        <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">Availability</h2>
        <p className="text-sm sm:text-base text-slate-600 mt-1">When can we count on you? Most of our events are in NYC and Long Island.</p>
      </div>

      <Field label="Available Days" required testId="field-available-days">
        <OptionCards name="available-days" value={data.availableDays} onChange={(v) => setField("availableDays", v)} options={AVAILABLE_DAYS} />
      </Field>

      <Field label="Comfortable with early mornings / late nights?" required testId="field-early-late">
        <YesNoCards name="early-late" value={data.earlyLate === "Other" ? "Other" : data.earlyLate} onChange={(v) => setField("earlyLate", v)} options={["Yes", "No", "Other"]} />
        {data.earlyLate === "Other" && (
          <TextField testId="input-early-late-other" value={data.earlyLateOther} onChange={(v) => setField("earlyLateOther", v)} placeholder="Tell us more…" />
        )}
      </Field>

      <Field label="Are you comfortable commuting to events in NYC?" required hint="Majority of our events are in NYC." testId="field-nyc-commute">
        <YesNoCards name="nyc-commute" value={data.nycCommute} onChange={(v) => setField("nycCommute", v)} />
      </Field>

      <Field label="Are you comfortable commuting to events in Long Island? (Nassau / Suffolk County)" required testId="field-li-commute">
        <YesNoCards name="li-commute" value={data.liCommute} onChange={(v) => setField("liCommute", v)} />
      </Field>

      <Field label="Typical availability window" hint="Example: Fridays after 3PM, weekends open" testId="field-availability-window">
        <TextField testId="input-availability-window" value={data.availabilityWindow} onChange={(v) => setField("availabilityWindow", v)} placeholder="Fridays after 3PM, weekends open" />
      </Field>
    </div>
  );
}
